import React from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";

import imgBanner from "assets/images/pages/haa-banner.jpg";
import imgIdeas2 from "assets/images/pages/haa/haa_ideas2.jpg";
import imgIdeas1 from "assets/images/pages/haa/haa-ideas1.jpg";
import imgResults from "assets/images/pages/haa/haa-results.png";
import imgPersion1 from "assets/images/pages/home/clients/GBI-Peter Custer.jpg";
import imgBusiness1 from "assets/images/pages/home/clients/gbi_logo.png";
import { PAGES } from "constants/pages";

const CaseStudyHAAPage = () => {
  const { t } = useTranslation();
  document.title = t(PAGES.CASE_STUDY_HAA.title);
  const data = {
    banner: {
      header: "caseStudies.HAA.banner.header",
      text: "caseStudies.HAA.banner.text",
      badges: t("caseStudies.HAA.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
    },
    stats: t("caseStudies.HAA.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.HAA.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.HAA.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.HAA.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t("caseStudies.HAA.businessChallenges", {
      returnObjects: true,
    }),
    ourSolutions: t("caseStudies.HAA.ourSolutions", {
      returnObjects: true,
    }),
    sthForOur: {
      header: "caseStudies.inspectMaster.sthForOur.header",
      client: {
        personName: t("homePage.paragraf5.items.item1.persion.name"),
        personPosition: t("homePage.paragraf5.items.item1.persion.position"),
        message: t("homePage.paragraf5.items.item1.text"),
        personImg: imgPersion1,
        businessImg: imgBusiness1,
        businessImgHeight: "55px",
        businessImgHeightSm: "35px",
      },
    },
    theResults: {
      header: "caseStudies.HAA.theResults.header",
      content: [
        {
          header: t("caseStudies.HAA.theResults.results.result1.text"),
          imageText: t("caseStudies.HAA.theResults.results.result1.number"),
          bgColor: "white",
        },
        {
          header: t("caseStudies.HAA.theResults.results.result2.text"),
          imageText: t("caseStudies.HAA.theResults.results.result2.number"),
          bgColor: "thertiary",
        },
        {
          header: t("caseStudies.HAA.theResults.results.result3.text"),
          imageText: t("caseStudies.HAA.theResults.results.result3.number"),
          bgColor: "thertiary",
        },
        {
          header: t("caseStudies.HAA.theResults.results.result4.text"),
          bgColor: "secondaryOpaque",
          image: imgResults,
        },
      ],
    },
    moreStories: {
      title: t("caseStudies.HAA.moreStories.header"),
      stories: t("caseStudies.HAA.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return <CaseStudyTemplatePage data={data} />;
};

export default CaseStudyHAAPage;
